import {
    ACCESS_POINTS_LIST_FILTER_CATEGORY,
    ACCESS_POINTS_LIST_FILTER_UPDATE,
    ACCESS_POINTS_LIST_PAGE,
    ACCESS_POINTS_LIST_SORT,
    CREATE_ACCESS_POINT_FAILURE,
    CREATE_ACCESS_POINT_SUCCESS,
    CREATE_ACCESS_POINT,
    FETCH_ACCESS_POINT_FAILURE,
    FETCH_ACCESS_POINT_SUCCESS,
    FETCH_ACCESS_POINT,
    FETCH_ACCESS_POINTS_FAILURE,
    FETCH_ACCESS_POINTS_SUCCESS,
    FETCH_ACCESS_POINTS,
    SORT_ASC,
    UPDATE_ACCESS_METHODS_FAILURE,
    UPDATE_ACCESS_POINT_SUCCESS,
    UPDATE_ACCESS_POINT,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'title',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CREATE_ACCESS_POINT:
        case FETCH_ACCESS_POINT:
        case FETCH_ACCESS_POINTS:
        case UPDATE_ACCESS_POINT:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_ACCESS_POINT_FAILURE:
        case FETCH_ACCESS_POINTS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_ACCESS_POINTS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const data = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: data,
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case FETCH_ACCESS_POINT_SUCCESS:
            return {
                ...state,
                data: Object.assign({}, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    action.response.id,
                ],
                loading: false,
            };

        case CREATE_ACCESS_POINT_SUCCESS:
            return {
                ...state,
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    action.response.id,
                ],
                loading: false,
            };

        case UPDATE_ACCESS_POINT_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.response.id]: action.response,
                },
                ids: [
                    ...state.ids,
                    action.response.id,
                ],
                loading: false,
            };

        case CREATE_ACCESS_POINT_FAILURE:
        case UPDATE_ACCESS_METHODS_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case ACCESS_POINTS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case ACCESS_POINTS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case ACCESS_POINTS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case ACCESS_POINTS_LIST_FILTER_UPDATE:
            const normalisedStatePayload = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, normalisedStatePayload);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/accessPointsReducer.js